import React from 'react';
import { Form } from 'react-bootstrap';
import { Field, Formik, Form as FormikForm } from 'formik';
import FormField from '../../../../components/FormField';
import SubmitBtn from '../../../../components/SubmitBtn';

const { Label } = Form;

function AuthForm({ fields = [], buttonLabel = 'Submit', submitStyle }) {
  const validate = (values) => {
    const errors = {};
    if (!values.city) errors.city = 'Required';
    return errors;
  };

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true)
    localStorage.setItem('chosenPartnerCity', JSON.stringify(values.city));
    window.location = '/register';
    setSubmitting(false)
    return
  };

  return (
    <div className="auth-wrap">
      <header className="rolzo-header text-center">
        <div className="mb-3">
          <img src="/images/rolzo_logo_black.png" alt="" />
        </div>
        <p>
          <span className="text-dark">Become a partner</span>
        </p>
      </header>

      <Formik
        initialValues={{ city: '' }}
        validate={validate}
        validateOnChange={false}
        onSubmit={handleSubmit}
      >
        {({  handleBlur, handleChange, values, errors, isSubmitting }) => (
          <FormikForm>
            {fields.map((f, i) => (
              <Field
                key={i}
                name={f.name}
                component={f.component || FormField}
                {...f}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[f.name]}
                isInvalid={!!errors[f.name]}
              />
            ))}

            <SubmitBtn
              title={'Next'}
              className={submitStyle}
              disabled={isSubmitting}
            />
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

export default AuthForm;